export default __webpack_public_path__ + "static/media/popArt.a642c9d6.png";